import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import { useAuth } from 'modules/Auth/Hooks';
import { useWidgets } from 'modules/Dashboard/Widgets/Hooks';
import { WidgetSettings } from 'modules/Dashboard/Widgets/Common';
import { UsersWidgetPlaceholder } from 'modules/Dashboard/Widgets/Users/Common';

import { MissingVideos as MissingVideosComponent } from './MissingVideos.component';
import { useMissingVideosWidget } from './useMissingVideosWidget';

export const MissingVideos = ({ widget, isMock }) => {
  const navigate = useNavigate();
  const { isSuperAdmin, userDateFormat, userTimeFormat, userTimezone } =
    useAuth();
  const { filters, state, changeFilters, loadMore } = useMissingVideosWidget({
    enabled: !!isSuperAdmin && !isMock,
    timezone: userTimezone,
    widgetId: widget?.id,
    defaultInterval: widget?.settings?.default_option,
  });
  const { saveWidgetSettings, removeActiveWidget } = useWidgets();
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  if (!isSuperAdmin) return null;

  if (isSettingsOpen) {
    return (
      <WidgetSettings
        widget={widget}
        onSave={saveWidgetSettings}
        onClose={() => setIsSettingsOpen(false)}
        onRemoveWidget={removeActiveWidget}
      />
    );
  }

  if (!isMock && !state.loaded) {
    return <UsersWidgetPlaceholder widget={widget} />;
  }

  return (
    <MissingVideosComponent
      widget={widget}
      isMock={isMock}
      onOpenSettings={() => setIsSettingsOpen(true)}
      sessions={isMock ? [] : state.sessions}
      loading={!isMock && state.loading}
      hasMore={!isMock && state.hasMore}
      hasError={!!state.error}
      filters={filters}
      authFormat={{ userDateFormat, userTimeFormat, userTimezone }}
      onChangeInterval={(interval) => changeFilters({ interval })}
      onChangeType={(missingType) => changeFilters({ missingType })}
      onLoadMore={loadMore}
      onOpenSession={(id) => navigate(`/antifraud/plugin/log/${id}`)}
    />
  );
};

MissingVideos.propTypes = {
  widget: PropTypes.object,
  isMock: PropTypes.bool,
};
